/**
 * Site-wide JavaScript
 * Handles navigation, theme switching, mobile menu, forms, and PWA
 */

document.addEventListener('DOMContentLoaded', function () {
  // Convert CSS preloads to stylesheets for async loading
  const mainCssPreload = document.getElementById('main-css-preload');
  const fontsCssPreload = document.getElementById('fonts-css-preload');

  if (mainCssPreload) {
    mainCssPreload.rel = 'stylesheet';
  }
  if (fontsCssPreload) {
    fontsCssPreload.rel = 'stylesheet';
  }

  // Show JavaScript-only elements when JS is available
  document.querySelectorAll('.js-only').forEach((el) => {
    el.classList.remove('js-only');
  });

  // Hide .js-hide elements when JS is available
  document.querySelectorAll('.js-hide').forEach((el) => {
    el.style.display = 'none';
  });

  // Theme management
  const themeToggle = document.getElementById('themeToggle');
  const themeDropdown = document.getElementById('themeDropdown');
  const themeSystem = document.getElementById('themeSystem');
  const themeLight = document.getElementById('themeLight');
  const themeDark = document.getElementById('themeDark');
  const html = document.documentElement;

  // Mobile theme elements
  const mobileThemeSystem = document.getElementById('mobileThemeSystem');
  const mobileThemeLight = document.getElementById('mobileThemeLight');
  const mobileThemeDark = document.getElementById('mobileThemeDark');

  // Icon elements
  const systemIcon = document.getElementById('systemIcon');
  const sunIcon = document.getElementById('sunIcon');
  const moonIcon = document.getElementById('moonIcon');

  // Check mark elements
  const systemCheck = document.getElementById('systemCheck');
  const lightCheck = document.getElementById('lightCheck');
  const darkCheck = document.getElementById('darkCheck');

  // Mobile check mark elements
  const mobileSystemCheck = document.getElementById('mobileSystemCheck');
  const mobileLightCheck = document.getElementById('mobileLightCheck');
  const mobileDarkCheck = document.getElementById('mobileDarkCheck');

  // Initialize theme
  function updateTheme(isInitialLoad = false) {
    const savedTheme = localStorage.getItem('theme');

    // Temporarily disable transitions during initial load to prevent CLS
    if (isInitialLoad) {
      document.body.style.transition = 'none';
    }

    // Hide all icons and checkmarks first
    if (systemIcon) systemIcon.classList.add('hidden');
    if (sunIcon) sunIcon.classList.add('hidden');
    if (moonIcon) moonIcon.classList.add('hidden');
    if (systemCheck) systemCheck.classList.add('hidden');
    if (lightCheck) lightCheck.classList.add('hidden');
    if (darkCheck) darkCheck.classList.add('hidden');

    // Hide mobile checkmarks and reset button styles
    if (mobileSystemCheck) mobileSystemCheck.classList.add('hidden');
    if (mobileLightCheck) mobileLightCheck.classList.add('hidden');
    if (mobileDarkCheck) mobileDarkCheck.classList.add('hidden');

    // Reset mobile button styles
    if (mobileThemeSystem) {
      mobileThemeSystem.classList.remove('text-gray-900', 'dark:text-white');
      mobileThemeSystem.classList.add('text-gray-600', 'dark:text-gray-400');
    }
    if (mobileThemeLight) {
      mobileThemeLight.classList.remove('text-gray-900', 'dark:text-white');
      mobileThemeLight.classList.add('text-gray-600', 'dark:text-gray-400');
    }
    if (mobileThemeDark) {
      mobileThemeDark.classList.remove('text-gray-900', 'dark:text-white');
      mobileThemeDark.classList.add('text-gray-600', 'dark:text-gray-400');
    }

    // Remove all theme classes first
    html.classList.remove('light', 'dark', 'system');

    if (savedTheme === 'light') {
      html.classList.add('light');
      if (sunIcon) sunIcon.classList.remove('hidden');
      if (lightCheck) lightCheck.classList.remove('hidden');
      // Mobile light theme active state
      if (mobileLightCheck) mobileLightCheck.classList.remove('hidden');
      if (mobileThemeLight) {
        mobileThemeLight.classList.remove(
          'text-gray-600',
          'dark:text-gray-400',
        );
        mobileThemeLight.classList.add('text-gray-900', 'dark:text-white');
      }
    } else if (savedTheme === 'system') {
      // System preference - check current system preference
      const currentSystemPrefersDark = window.matchMedia(
        '(prefers-color-scheme: dark)',
      ).matches;
      html.classList.add('system');
      if (currentSystemPrefersDark) {
        html.classList.add('dark');
      } else {
        html.classList.add('light');
      }
      if (systemIcon) systemIcon.classList.remove('hidden');
      if (systemCheck) systemCheck.classList.remove('hidden');
      // Mobile system theme active state
      if (mobileSystemCheck) mobileSystemCheck.classList.remove('hidden');
      if (mobileThemeSystem) {
        mobileThemeSystem.classList.remove(
          'text-gray-600',
          'dark:text-gray-400',
        );
        mobileThemeSystem.classList.add('text-gray-900', 'dark:text-white');
      }
    } else {
      // Default to dark (both when saved as 'dark' and when no theme is set)
      if (!savedTheme) {
        localStorage.setItem('theme', 'dark');
      }
      html.classList.add('dark');
      if (moonIcon) moonIcon.classList.remove('hidden');
      if (darkCheck) darkCheck.classList.remove('hidden');
      // Mobile dark theme active state
      if (mobileDarkCheck) mobileDarkCheck.classList.remove('hidden');
      if (mobileThemeDark) {
        mobileThemeDark.classList.remove('text-gray-600', 'dark:text-gray-400');
        mobileThemeDark.classList.add('text-gray-900', 'dark:text-white');
      }
    }

    // Re-enable transitions after theme is applied (only on initial load)
    if (isInitialLoad) {
      // Use requestAnimationFrame to ensure DOM updates are complete
      requestAnimationFrame(() => {
        document.body.style.transition = '';
      });
    }
  }

  // Initialize theme on load
  updateTheme(true);

  // Theme toggle dropdown functionality
  if (themeToggle && themeDropdown) {
    themeToggle.addEventListener('click', function (e) {
      e.stopPropagation();
      themeDropdown.classList.toggle('hidden');
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', function (e) {
      if (
        !themeToggle.contains(e.target) &&
        !themeDropdown.contains(e.target)
      ) {
        themeDropdown.classList.add('hidden');
      }
    });
  }

  // Theme option handlers
  if (themeSystem) {
    themeSystem.addEventListener('click', function () {
      localStorage.setItem('theme', 'system');
      themeDropdown.classList.add('hidden');
      updateTheme();
    });
  }

  if (themeLight) {
    themeLight.addEventListener('click', function () {
      localStorage.setItem('theme', 'light');
      themeDropdown.classList.add('hidden');
      updateTheme();
    });
  }

  if (themeDark) {
    themeDark.addEventListener('click', function () {
      localStorage.setItem('theme', 'dark');
      themeDropdown.classList.add('hidden');
      updateTheme();
    });
  }

  // Mobile theme option handlers
  if (mobileThemeSystem) {
    mobileThemeSystem.addEventListener('click', function () {
      localStorage.setItem('theme', 'system');
      updateTheme();
    });
  }

  if (mobileThemeLight) {
    mobileThemeLight.addEventListener('click', function () {
      localStorage.setItem('theme', 'light');
      updateTheme();
    });
  }

  if (mobileThemeDark) {
    mobileThemeDark.addEventListener('click', function () {
      localStorage.setItem('theme', 'dark');
      updateTheme();
    });
  }

  // Listen for system theme changes
  window
    .matchMedia('(prefers-color-scheme: dark)')
    .addEventListener('change', function () {
      if (localStorage.getItem('theme') === 'system') {
        updateTheme();
      }
    });

  // Desktop dropdown functionality for navigation items with children
  const dropdownButtons = document.querySelectorAll('[id$="-button"]');
  const activeDropdowns = new Set();
  const mousePosition = { x: 0, y: 0 };

  // Track mouse position
  document.addEventListener('mousemove', function (e) {
    mousePosition.x = e.clientX;
    mousePosition.y = e.clientY;
  });

  // Function to close dropdown with fade out
  function closeDropdown(dropdownId) {
    const dropdown = document.getElementById(`desktop-menu-${dropdownId}`);
    if (dropdown) {
      dropdown.classList.remove('opacity-100', 'scale-100');
      dropdown.classList.add('opacity-0', 'scale-95', 'pointer-events-none');
      activeDropdowns.delete(dropdownId);
    }
  }

  dropdownButtons.forEach((button) => {
    const buttonId = button.id;
    const dropdownId = buttonId.replace('-button', '');
    const dropdown = document.getElementById(`desktop-menu-${dropdownId}`);

    if (dropdown) {
      // Mouse distance tracking
      let distanceCheckInterval;

      function startDistanceTracking() {
        if (distanceCheckInterval) clearInterval(distanceCheckInterval);

        let awayFromSafeZoneTimer;

        // Function to check if mouse is in safe zone (between button and dropdown)
        function isMouseInSafeZone() {
          const buttonRect = button.getBoundingClientRect();
          const dropdownRect = dropdown.getBoundingClientRect();

          // Create a safe zone that includes both elements and the space between them
          const safeLeft = Math.min(buttonRect.left, dropdownRect.left) - 20;
          const safeRight = Math.max(buttonRect.right, dropdownRect.right) + 20;
          const safeTop = Math.min(buttonRect.top, dropdownRect.top) - 20;
          const safeBottom =
            Math.max(buttonRect.bottom, dropdownRect.bottom) + 20;

          return (
            mousePosition.x >= safeLeft &&
            mousePosition.x <= safeRight &&
            mousePosition.y >= safeTop &&
            mousePosition.y <= safeBottom
          );
        }

        // Clear all timers
        function clearAllTimers() {
          if (awayFromSafeZoneTimer) clearTimeout(awayFromSafeZoneTimer);
          if (distanceCheckInterval) clearInterval(distanceCheckInterval);
        }

        // Start checking if mouse is in safe zone
        distanceCheckInterval = setInterval(() => {
          if (!activeDropdowns.has(dropdownId)) {
            clearAllTimers();
            return;
          }

          const inSafeZone = isMouseInSafeZone();

          if (inSafeZone) {
            // User is in safe zone (button, dropdown, or between them)
            // Clear the away timer since user is in safe area
            if (awayFromSafeZoneTimer) {
              clearTimeout(awayFromSafeZoneTimer);
              awayFromSafeZoneTimer = null;
            }
          } else if (!awayFromSafeZoneTimer) {
            // User has moved outside safe zone, start timer
            awayFromSafeZoneTimer = setTimeout(() => {
              if (activeDropdowns.has(dropdownId)) {
                closeDropdown(dropdownId);
                clearAllTimers();
              }
            }, 100);
          }
        }, 50); // Check every 50ms for more responsive tracking
      }

      // Show dropdown on hover
      button.addEventListener('mouseenter', function () {
        // Close all other dropdowns first
        activeDropdowns.forEach((activeId) => {
          if (activeId !== dropdownId) {
            const activeDropdown = document.getElementById(
              `desktop-menu-${activeId}`,
            );
            if (activeDropdown) {
              activeDropdown.classList.remove('opacity-100', 'scale-100');
              activeDropdown.classList.add(
                'opacity-0',
                'scale-95',
                'pointer-events-none',
              );
              activeDropdowns.delete(activeId);
            }
          }
        });

        // Show current dropdown
        if (dropdown.classList.contains('opacity-0')) {
          dropdown.classList.remove(
            'opacity-0',
            'scale-95',
            'pointer-events-none',
          );
          dropdown.classList.add('opacity-100', 'scale-100');
          activeDropdowns.add(dropdownId);
          startDistanceTracking();
        }
      });

      // Open dropdown on focus (tab navigation)
      button.addEventListener('focus', function () {
        // Close all other dropdowns first
        activeDropdowns.forEach((activeId) => {
          if (activeId !== dropdownId) {
            const activeDropdown = document.getElementById(
              `desktop-menu-${activeId}`,
            );
            if (activeDropdown) {
              activeDropdown.classList.remove('opacity-100', 'scale-100');
              activeDropdowns.delete(activeId);
            }
          }
        });

        // Open current dropdown if it's closed
        if (dropdown.classList.contains('opacity-0')) {
          dropdown.classList.remove(
            'opacity-0',
            'scale-95',
            'pointer-events-none',
          );
          dropdown.classList.add('opacity-100', 'scale-100');
          activeDropdowns.add(dropdownId);
          startDistanceTracking();
        }
      });

      // Prevent dropdown from closing when clicking inside it
      dropdown.addEventListener('click', function (e) {
        e.stopPropagation();
      });

      // Close dropdown when focus leaves the dropdown area
      dropdown.addEventListener('focusout', function () {
        // Use setTimeout to allow focus to move to the next element
        setTimeout(() => {
          // Check if the new focus target is still within the dropdown or button
          const focusedElement = document.activeElement;
          if (
            !dropdown.contains(focusedElement) &&
            !button.contains(focusedElement)
          ) {
            closeDropdown(dropdownId);
          }
        }, 0);
      });

      // Ensure dropdown is visible when any focusable element within it receives focus
      const focusableElements = dropdown.querySelectorAll(
        'a, button, [tabindex]:not([tabindex="-1"])',
      );
      focusableElements.forEach((element) => {
        element.addEventListener('focus', function () {
          // Close all other dropdowns first
          activeDropdowns.forEach((activeId) => {
            if (activeId !== dropdownId) {
              const activeDropdown = document.getElementById(
                `desktop-menu-${activeId}`,
              );
              if (activeDropdown) {
                activeDropdown.classList.remove('opacity-100', 'scale-100');
                activeDropdown.classList.add(
                  'opacity-0',
                  'scale-95',
                  'pointer-events-none',
                );
                activeDropdowns.delete(activeId);
              }
            }
          });

          // Ensure current dropdown is visible
          if (dropdown.classList.contains('opacity-0')) {
            dropdown.classList.remove(
              'opacity-0',
              'scale-95',
              'pointer-events-none',
            );
            dropdown.classList.add('opacity-100', 'scale-100');
            activeDropdowns.add(dropdownId);
            startDistanceTracking();
          }
        });
      });
    }
  });

  // Close all dropdowns when clicking outside
  document.addEventListener('click', function (e) {
    let clickedInside = false;
    dropdownButtons.forEach((button) => {
      const dropdownId = button.id.replace('-button', '');
      const dropdown = document.getElementById(`desktop-menu-${dropdownId}`);
      if (
        button.contains(e.target) ||
        (dropdown && dropdown.contains(e.target))
      ) {
        clickedInside = true;
      }
    });

    if (!clickedInside) {
      activeDropdowns.forEach((dropdownId) => {
        const dropdown = document.getElementById(`desktop-menu-${dropdownId}`);
        if (dropdown) {
          dropdown.classList.remove('opacity-100', 'scale-100');
          dropdown.classList.add(
            'opacity-0',
            'scale-95',
            'pointer-events-none',
          );
        }
      });
      activeDropdowns.clear();
    }
  });

  // Close all dropdowns on escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      activeDropdowns.forEach((dropdownId) => {
        const dropdown = document.getElementById(`desktop-menu-${dropdownId}`);
        if (dropdown) {
          dropdown.classList.remove('opacity-100', 'scale-100');
          dropdown.classList.add(
            'opacity-0',
            'scale-95',
            'pointer-events-none',
          );
        }
      });
      activeDropdowns.clear();
    }
  });

  // Mobile menu functionality with animations
  const mobileMenuButton = document.querySelector('[commandfor="mobile-menu"]');
  const mobileMenu = document.getElementById('mobile-menu');
  const mobileMenuBackdrop = document.getElementById('mobile-menu-backdrop');
  const mobileMenuPanel = document.getElementById('mobile-menu-panel');
  const mobileMenuClose = document.querySelector(
    '[command="close"][commandfor="mobile-menu"]',
  );

  function openMobileMenu() {
    if (mobileMenu && mobileMenuBackdrop && mobileMenuPanel) {
      mobileMenu.showModal();
      // Trigger animations after modal is shown
      requestAnimationFrame(() => {
        // Animate backdrop blur and opacity
        mobileMenuBackdrop.classList.remove(
          'opacity-0',
          'bg-black/0',
          'backdrop-blur-none',
        );
        mobileMenuBackdrop.classList.add(
          'opacity-100',
          'bg-black/20',
          'backdrop-blur-sm',
        );
        // Animate panel slide in
        mobileMenuPanel.classList.remove('translate-x-full');
        mobileMenuPanel.classList.add('translate-x-0');
      });
    }
  }

  function closeMobileMenu() {
    if (mobileMenu && mobileMenuBackdrop && mobileMenuPanel) {
      // Animate out
      mobileMenuBackdrop.classList.remove(
        'opacity-100',
        'bg-black/20',
        'backdrop-blur-sm',
      );
      mobileMenuBackdrop.classList.add(
        'opacity-0',
        'bg-black/0',
        'backdrop-blur-none',
      );
      mobileMenuPanel.classList.remove('translate-x-0');
      mobileMenuPanel.classList.add('translate-x-full');

      // Close modal after animation completes
      setTimeout(() => {
        mobileMenu.close();
      }, 300); // Match transition duration
    }
  }

  if (mobileMenuButton && mobileMenu) {
    mobileMenuButton.addEventListener('click', function (e) {
      e.preventDefault();
      openMobileMenu();
    });
  }

  if (mobileMenuClose && mobileMenu) {
    mobileMenuClose.addEventListener('click', function (e) {
      e.preventDefault();
      closeMobileMenu();
    });
  }

  // Close mobile menu when clicking backdrop
  if (mobileMenu && mobileMenuBackdrop) {
    mobileMenuBackdrop.addEventListener('click', function (e) {
      if (e.target === mobileMenuBackdrop) {
        closeMobileMenu();
      }
    });
  }

  // Mobile dropdown functionality for navigation items with children
  const mobileDropdownButtons = document.querySelectorAll(
    '[command="--toggle"]',
  );

  mobileDropdownButtons.forEach((button) => {
    const targetId = button.getAttribute('commandfor');
    const dropdown = document.getElementById(targetId);

    if (dropdown) {
      button.addEventListener('click', function (e) {
        e.preventDefault();

        // Toggle the dropdown
        if (dropdown.hasAttribute('hidden')) {
          dropdown.removeAttribute('hidden');
          button.setAttribute('aria-expanded', 'true');
        } else {
          dropdown.setAttribute('hidden', '');
          button.setAttribute('aria-expanded', 'false');
        }
      });
    }
  });

  // Toast notification functionality
  window.showToast = function () {
    const toast = document.getElementById('contact-toast');
    if (toast) {
      // Show toast with slide-in animation
      toast.classList.remove('hidden', 'translate-x-full');
      toast.classList.add('translate-x-0');

      // Set focus on toast for accessibility
      toast.focus();

      // Auto-hide after 5 seconds
      setTimeout(() => {
        hideToast();
      }, 5000);
    }
  };

  window.hideToast = function () {
    const toast = document.getElementById('contact-toast');
    if (toast) {
      // Slide out animation
      toast.classList.remove('translate-x-0');
      toast.classList.add('translate-x-full');

      // Hide after animation completes
      setTimeout(() => {
        toast.classList.add('hidden');
      }, 300); // Match transition duration
    }
  };

  // Handle toast close button click
  const toastCloseBtn = document.getElementById('toast-close-btn');
  if (toastCloseBtn) {
    toastCloseBtn.addEventListener('click', hideToast);
  }

  // Check for form submission success on page load
  const urlParams = new URLSearchParams(window.location.search);
  if (
    urlParams.get('submitted') === 'true' ||
    (window.location.pathname === '/contact/' && urlParams.has('success'))
  ) {
    // Show toast notification for successful form submission
    setTimeout(() => {
      showToast();
    }, 100); // Small delay to ensure page is fully loaded
  }

  // Handle form submission with AJAX
  const contactForm = document.querySelector('form[name="contact"]');
  if (contactForm) {
    contactForm.addEventListener('submit', function (e) {
      e.preventDefault();

      const formData = new FormData(contactForm);
      // Add form-name for Netlify Forms
      formData.append('form-name', 'contact');

      // Submit to Netlify via AJAX
      fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData).toString(),
      })
        .then(() => {
          // Reset form
          contactForm.reset();
          // Show success toast
          showToast();
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.error('Form submission error:', error);
          // Could add error toast here in the future
          alert('There was an error submitting the form. Please try again.');
        });
    });
  }

  // Register Service Worker (only in production)
  if (
    'serviceWorker' in navigator &&
    !window.location.hostname.includes('localhost')
  ) {
    // A page served by an older worker may be stale cached HTML. Reload once
    // when a new worker takes over so visitors get the current page. First
    // visits (no previous controller) never reload.
    const hadController = Boolean(navigator.serviceWorker.controller);
    let reloading = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (!hadController || reloading) return;
      reloading = true;
      window.location.reload();
    });

    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/sw.js')
        .then((registration) => {
          // Service Worker registered successfully
          // eslint-disable-next-line no-console
          console.log(
            'Service Worker registered with scope:',
            registration.scope,
          );
          // Check for a newer worker now rather than waiting for the browser
          registration.update();
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log('Service Worker registration failed:', error);
        });
    });
  }
});
